/**
 * Main menu functionality for slide animations.
 *
 * @package  Globus
 * @since    1.0.0
 */

/**
 * Import dependencies.
 */
import * as helpers from '../global/helpers';

/**
 * Add slide-in up clas if slide-me is in viewport.
 */
function initSlideAnimations() {
	const slideClass = document.getElementsByClassName('slide-me');
	let i;

	for (i = 0; i < slideClass.length; i++) {
		if (slideClass[i]) {
			if (helpers.isElementInViewport(slideClass[i])) {
				slideClass[i].classList.add('slide-in-up');
			}
		}
	}
}

window.addEventListener('DOMContentLoaded', initSlideAnimations);
window.addEventListener('resize', initSlideAnimations);
window.addEventListener('scroll', initSlideAnimations);
